import React from "react"

import DineroFactory from "dinero.js"

import {
  CartItemContainer,
  InfoWrapper,
  ItemDetails, ItemImage,
  ItemName,
  ItemPrice,
  SalePrice
} from "./CartItem.styled"
import Money from "../../../../../Money"
import { ShippingFee } from "lib/types/generated/graphql-types"
import { Id } from "../../Shared.styled"
import { ReactComponent as ShippingIcon } from "images/icons/cart-flatbed-boxes.svg"

type Props = {
  shippingFee: ShippingFee
  currencyCode?: string
  refetch: () => void
}

const CartItem = ({ shippingFee, currencyCode, ...props }: Props) => {
  const hasDiscount = () => shippingFee.basePriceAmount !== shippingFee.salePriceAmount

  return (
    <CartItemContainer {...props}>
      <InfoWrapper>
        <ItemImage>
          <ShippingIcon/>
        </ItemImage>

        <ItemDetails>
          <ItemName>{shippingFee?.name}</ItemName>
          <ItemPrice>
            <SalePrice $hasDiscount={hasDiscount()}>
              <Money
                amount={Number(shippingFee?.basePriceAmount)}
                currencyUnit={currencyCode as DineroFactory.Currency}
              />
            </SalePrice>
            {hasDiscount() && (
              <Money
                amount={Number(shippingFee?.salePriceAmount)}
                currencyUnit={currencyCode as DineroFactory.Currency}
              />
            )}
          </ItemPrice>
          <Id>
            <b>Id: </b>
            {shippingFee.id}
          </Id>
        </ItemDetails>
      </InfoWrapper>
    </CartItemContainer>
  )
}

export default CartItem
